document.addEventListener("DOMContentLoaded", function () {
  // 获取外层导航容器
  const navWrap = document.querySelector(".product-module-nav-module");
  const navLayout = document.querySelector(".module-nav-layout");
  const navItems = document.querySelectorAll(".module-nav-item");

  if (!navWrap || !navLayout || navItems.length === 0) return;

  // ========== 1. 导航模块滚出视口判断 ==========
  function isNavOutOfViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom < 0;
  }

  // ========== 2. 导航项切换active公共方法 ==========
  function setActiveNavItem(activeItem) {
    navItems.forEach(item => {
      item.classList.remove("active");
    });
    if (activeItem) activeItem.classList.add("active");
  }

  // ========== 3. 点击导航项事件 ==========
  navItems.forEach(item => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      setActiveNavItem(this);
      const targetId = this.getAttribute("href");
      const targetEl = document.querySelector(targetId);
      if (targetEl) {
        // 平滑滚动
        targetEl.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });

  // ========== 4. 滚动时同步：悬浮导航判断 + 区块自动高亮导航 ==========
  function handleScroll() {
    // 悬浮导航开关
    if (isNavOutOfViewport(navWrap)) {
      navLayout.classList.add("active");
    } else {
      navLayout.classList.remove("active");
    }

    // 滚动自动匹配当前区块，高亮对应的导航
    let currentSection = null;
    navItems.forEach(item => {
      const targetId = item.getAttribute("href");
      const section = document.querySelector(targetId);
      if (!section) return;
      const rect = section.getBoundingClientRect();
      if (rect.top <= 100) {
        currentSection = item;
      }
    });
    if (currentSection) {
      setActiveNavItem(currentSection);
    }
  }

  // 节流
  let ticking = false;
  function scrollHandler() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener("scroll", scrollHandler);
  // 页面初始化执行一次
  handleScroll();
});
